export enum ElectricalWorkType {
  Electrical,
  NonElectrical,
  QualifiedSupervisor
}
export enum ElectricalWorkTypeString {
  'Electrical', //0
  'Non Electrical', //1
  'Qualified Supervisor' //2
}
